import type { BadgeProps } from 'antd';

import { StyledBadge } from '@atom/badge/badge.style';

export const Badge = (props: BadgeProps) => <StyledBadge {...props} />;
